var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center"},[(_vm.loading)?_c('progress-bar'):_c('WorkerReportManager',{attrs:{"groupedQuerylogs":_vm.groupedQuerylogs,"chart-colors":_vm.chartColors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }